var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"SectionTitle"},[_c('Column',{attrs:{"sm":8}},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),(_vm.$slots.default)?_c('Column',{attrs:{"sm":4}},[_c('div',{staticClass:"filters"},[_vm._t("default")],2)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }